import React, { createContext, useContext, useState, useEffect } from 'react';
import { cmsApi, clearApiCache } from '../api';

const CITY_KEY = 'zende_city';

const CityContext = createContext(null);

export function CityProvider({ children }) {
  const [cities, setCities]             = useState([]);
  const [selectedCity, setSelectedCityState] = useState(
    () => localStorage.getItem(CITY_KEY) || ''
  );

  // Fetch active cities once on mount
  useEffect(() => {
    cmsApi.getCities()
      .then(data => {
        setCities(data);
        // If no city selected yet, default to first active city
        if (!localStorage.getItem(CITY_KEY) && data.length > 0) {
          setSelectedCityState(data[0].name);
          localStorage.setItem(CITY_KEY, data[0].name);
        }
      })
      .catch(() => {/* non-critical — UI degrades gracefully */});
  }, []);

  const setSelectedCity = (cityName) => {
    setSelectedCityState(cityName);
    clearApiCache(); // bust the in-memory cache so the new city's data is fetched fresh
    if (cityName) {
      localStorage.setItem(CITY_KEY, cityName);
    } else {
      localStorage.removeItem(CITY_KEY);
    }
  };

  return (
    <CityContext.Provider value={{ cities, selectedCity, setSelectedCity }}>
      {children}
    </CityContext.Provider>
  );
}

export const useCity = () => useContext(CityContext);
